module.exports = __webpack_public_path__ + "img/img9.591a7932.svg";